import { memo } from 'react'
import { useUser } from '@shared/hooks/user'

import {
    BrowserRouter,
    Routes,
    Route,
    Outlet,
    Navigate,
} from 'react-router-dom'

import AuthLayout from '@app/layouts/auth/Layout'
import DashboardLayout from '@app/layouts/dashboard/Layout'

import Login from '@features/login/Form'
import Signup from '@features/signup/Form'
import Logout from '@features/logout/Redirection'

import QuickLook from '@features/feed/QuickLook'
import Estimations from '@features/estimations/Main'
import Offices from '@features/offices/Main'
import Users from '@features/users/Users'
import Account from '@features/account/Account'

import NotFound from '@features/general/NotFound'

const Guard = memo(function ({ show, redirectTo }) {
    if (show === null) return null
    if (!show) return <Navigate to={redirectTo} replace />
    return <Outlet />
})

export default function Router() {
    const user = useUser()
    const isAuthenticated = user.isAuthenticated

    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Navigate to='/auth/login' replace />}/>
                    <Route element={<Guard show={isAuthenticated === null ? null : !isAuthenticated} redirectTo='/dashboard/' />}>
                        <Route path='auth' element={<AuthLayout />}>
                            <Route index element={<Navigate to='login' replace />} />
                            <Route path='login' element={<Login />}/>
                            <Route path='signup' element={<Signup />}/>
                        </Route>
                    </Route>
                    <Route element={<Guard show={isAuthenticated} redirectTo='/auth/login' />}>
                        <Route path='dashboard' element={<DashboardLayout />}>
                            <Route index element={<QuickLook />}/>
                            <Route path='estimations' element={<Estimations />}/>
                            <Route path='offices' element={<Offices />}/>
                            <Route path='users' element={<Users />}/>
                            <Route path='account' element={<Account />}/>
                        </Route>
                        <Route path='auth/logout' element={<Logout />}/>
                    </Route>

                    <Route path='*' element={<NotFound />}/>
                </Routes>
            </BrowserRouter>
        </>
    )
}